const normalizeLanguage = (language: string | null | undefined) =>
  (language || "en").split("-")[0].toLowerCase();

export const buildLogoutCompletionUrl = (
  origin: string,
  language: string | null | undefined
) => new URL(`/${normalizeLanguage(language)}/logout-complete`, origin).toString();

export const buildCentralLogoutUrl = ({
  authBaseUrl,
  appId,
  language,
  consumerOrigin,
}: {
  authBaseUrl: string;
  appId: string;
  language: string | null | undefined;
  consumerOrigin: string;
}) => {
  const normalizedLanguage = normalizeLanguage(language);
  const logoutUrl = new URL(`${authBaseUrl.replace(/\/$/, "")}/${normalizedLanguage}/logout/`);

  logoutUrl.searchParams.set("appId", appId);
  logoutUrl.searchParams.set(
    "referer",
    buildLogoutCompletionUrl(consumerOrigin, normalizedLanguage)
  );

  return logoutUrl.toString();
};
